<template>
  <div class="flex flex-wrap py-4 md:py-0 gap-2 w-full justify-center">
    <BaseDatePicker
      v-model="selectedDate"
      :available-dates="availableDates" 
      :min-date="minDate"
      :max-date="maxDate"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue';
  import { useRouter } from 'vue-router';

  import { useGeneralStore } from '@/stores/general';
  import { getEventtime } from '@/utils/eventItemUtil';

  import BaseDatePicker from '../ui/BaseDatePicker.vue';

  const router = useRouter();
  const emit = defineEmits(['onChange']);

  const generalStore = useGeneralStore();
  const events = computed(() => generalStore.events());

  const availableDates = computed(() =>
    events.value
      .filter(event => event.frontpage_event_highlight_in_calendar == true)
      .map(event => getEventtime(event))
  );

  const minDate = computed(() => new Date(Math.min(...availableDates.value) * 1000));
  const maxDate = computed(() => new Date(Math.max(...availableDates.value) * 1000));

  const selectedDate = ref<number | undefined>();

  watch(selectedDate, newDate => {
    router.push({
      path: '/',
      query: { date: newDate ? newDate.toString() : undefined },
    });
    emit('onChange');
  });
</script>
